module.exports = __webpack_public_path__ + "img/PAMMAccountCardModel2.f16017f9.png";